<div class="slider" (throttleClick)="onPlay()" data-testid="hero_slider">

    <div class="slides" (transitionend)="handleTransitionEnd()"
        [style.transform]="'translateX(-' + displayIndex() * 100 + '%)'"
        [style.transition]="isTransitioning() ? 'transform 1s ease-in-out' : 'none'">
        @for (item of itemsWithClones(); track $index) {
        <!-- Width-only transcode: the slide box (100vw × 46.25vw, min-height 600px) is wider than any
             poster, and with both axes the transcoder CROPS the image to that box — centred, so the top of
             the artwork went missing. Fetching at the box's width keeps the poster's own aspect ratio and
             leaves the crop to `background-size: cover` + `background-position: top` below, as designed
             (legacy always fetched the full 1920×1080 for the same reason). -->
        <div class="slide" [transcodeImage]="item.posterLandscape" transcodeAxis="width">
            @if (gate.isRestricted(item)) {
            <content-rating-lock />
            }
        </div>
        }
    </div>

    <div class="player" [ngClass]="{ 'playing': previewVideoPlaying() }">
        <ng-container #playerContainer></ng-container>
    </div>

    <div class="navigation-buttons" [ngClass]="{ 'focused': isFocused() }" (click)="$event.stopPropagation()">
        <rounded-icon-button class="nav left" (onClick)="prevSlide()" [imgSrc]="skinning.getImage('arrow_primary')"
            [disabled]="isSliding()" [imgRotate]=180 data-testid="hero_nav-prev"></rounded-icon-button>
        <rounded-icon-button class="nav right" (onClick)="nextSlide()" [disabled]="isSliding()"
            [imgSrc]="skinning.getImage('arrow_primary')" data-testid="hero_nav-next"></rounded-icon-button>
    </div>

    <rounded-icon-button class="mute-btn" data-testid="hero_mute" (onClick)="togglePreviewVideoMute()" (click)="$event.stopPropagation()"
        [ngClass]="{ 'playing': previewVideoPlaying() }"
        [imgSrc]="skinning.getImage(playerMuted()?'icon_sound_off':'icon_sound_on')"></rounded-icon-button>

    <div class="content flex flex-col left" [class.animate-content]="animateContent()">
        @if (showBadge()) {
        <badge [badge]="item()?.badge" [variant]="BadgeVariant.Cover" [availabilityStartTime]="item()?.availabilityStartTime" [availabilityEndTime]="item()?.availabilityEndTime" [hasUpcomingEnabled]="item()?.hasUpcomingEnabled" [hasOutgoingEnabled]="item()?.hasOutgoingEnabled" [showAutomaticBadge]="isAutoBadgeEpisode()" (availabilityStartPassed)="onAvailabilityStartPassed($event)"></badge>
        }

        @if(settings.showSubtitle() && item()?.subtitle){
        <div class="title font-large cursor-default" (click)="$event.stopPropagation()">
            {{ item()?.subtitle }}
        </div>
        }
        @if(item()?.channelIcon){
        <div class="channel-icon cursor-default" (click)="$event.stopPropagation()">
            <!-- Channel logo: natural-sized (no CSS box), so keep the raw src —
                 transcoding to a fixed box would blow it up. -->
            <img [src]="item()?.channelIcon" />
        </div>
        }
        @if(!item()?.hideTitle && item()?.title ){
        <div class="title font-xxxlarge font-bold line-clamp-2 cursor-default" (click)="$event.stopPropagation()">
            {{ gate.isRestricted(item()) ? ('common.protected_content_title' | transloco) : item()?.title }}
        </div>
        }
        @if(showHeroDescription()){
        <div class="description font-medium line-clamp-3 cursor-default" (click)="$event.stopPropagation()">
            {{ item()?.description }}
        </div>
        }
    </div>

    <div class="actions left right flex flex-row" [class.animate-content]="animateContent()">
        @if(showPlayButton()){
        <div>
            <button id="mainPlayButton" class="primary play-button button icon-button button-sm" data-testid="hero_play"
                (mouseenter)="stopSlideShow()" (mouseleave)="startSlideShow()" (throttleClick)="onPlay()">
                <img src="{{skinning.getImage('icon_play')}}">
                <div>{{ 'vod.buttons.play' | transloco }}</div>
            </button>
        </div>
        }
        <div>
            <button class="secondary button icon-button button-sm" data-testid="hero_details" (mouseenter)="stopSlideShow()"
                (mouseleave)="startSlideShow()" (click)="$event.stopPropagation(); openDetails()">
                <img src="{{skinning.getImage('icon_more_round')}}">
                <div>{{ 'vod.buttons.more_details' | transloco }}</div>
            </button>
        </div>

        <div class="dots" (click)="$event.stopPropagation()">
            @for (item of items(); track $index) {
            <span [class.active]="$index === currentIndex()" (click)="onDot($index)" data-testid="hero_slide-dot"></span>
            }
        </div>

    </div>

    <div class="shadow bottom-shadow"></div>

</div>